var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expande-horizontal pt-3 wrap"},_vm._l((_vm.filteredSales),function(sale){return _c('v-flex',{key:sale._id,attrs:{"xs6":""}},[_c('SaleItemMini',{attrs:{"statusType":_vm.statusType,"sale":sale}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }